/* eslint-disable @typescript-eslint/no-explicit-any */
import { BlocklyType } from '../@types/BlocklyType';

export class GlobalImport {
  static getAnyWindow(): any {
    return window as any;
  }
  static getBlockly(): BlocklyType {
    return this.getAnyWindow().Blockly;
  }
  static getAFRAME(): any {
    return this.getAnyWindow().AFRAME;
  }
  static getTHREE(): any {
    return this.getAnyWindow().THREE;
  }
  static getAce(): any {
    return this.getAnyWindow().ace;
  }
  static getNAF(): any {
    return this.getAnyWindow().NAF;
  }
  static getBootstrap(): any {
    return this.getAnyWindow().bootstrap;
  }
  static getSpeechRecognition(): any {
    const window = this.getAnyWindow();
    return new window.webkitSpeechRecognition();
  }
}
